import { OptionModel } from 'models/option';
import { mapGenericDropdownOptions } from 'helpers/dropdown-options';

export default function mapOptions(options: OptionModel[]) {
  return mapGenericDropdownOptions(options, { fields: { value: 'url', label: 'name' } });
}
